import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Clock, AlertTriangle, CheckCircle2, XCircle, Stamp } from "lucide-react";
import ApprovalsTable from "./ApprovalsTable";

export default function ApproverDashboard() {
  const { user } = useAuth();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/approver/dashboard").then((r) => setData(r.data)).catch(() => toast.error("Failed to load dashboard"));
  }, []);

  if (!data) return <div className="flex h-64 items-center justify-center" data-testid="approver-dashboard-loading"><Clock className="h-6 w-6 animate-spin text-slate-400" /></div>;
  const { kpis, pending_approvals } = data;
  const cards = [
    { label: "Pending Approvals", value: kpis.pending, icon: Clock, testid: "kpi-pending-approvals" },
    { label: "Overdue", value: kpis.overdue, icon: AlertTriangle, testid: "kpi-overdue-approvals", red: true },
    { label: "Approved", value: kpis.approved, icon: CheckCircle2, testid: "kpi-approved-approvals" },
    { label: "Rejected", value: kpis.rejected, icon: XCircle, testid: "kpi-rejected-approvals" },
    { label: "Total Decisions", value: kpis.total, icon: Stamp, testid: "kpi-total-approvals" },
  ];

  return (
    <div data-testid="approver-dashboard" className="space-y-6">
      <div>
        <h1 className="font-heading text-2xl font-semibold tracking-tight" data-testid="approver-greeting">Welcome, {user?.name}</h1>
        <p className="text-sm font-medium text-slate-600" data-testid="approver-org">{data.org_name}</p>
        <p className="text-sm text-muted-foreground">Review pending sourcing approvals and make informed decisions.</p>
      </div>
      <div className="grid grid-cols-2 gap-4 md:grid-cols-5">
        {cards.map((c) => (
          <div key={c.label} className="rounded-lg border bg-card p-4" data-testid={c.testid}>
            <div className="flex items-center justify-between">
              <p className="text-xs uppercase tracking-wide text-muted-foreground">{c.label}</p>
              <c.icon className={`h-4 w-4 ${c.red ? "text-[#DC2626]" : "text-slate-400"}`} />
            </div>
            <p className={`mt-2 font-heading text-2xl font-semibold ${c.red && c.value > 0 ? "text-[#DC2626]" : ""}`}>{c.value}</p>
          </div>
        ))}
      </div>
      <div>
        <h2 className="mb-3 font-heading text-base font-semibold">Pending Approvals</h2>
        <ApprovalsTable approvals={pending_approvals} />
      </div>
    </div>
  );
}
